/**
 * Utilitários de formatação locais da feature (datas pt-BR e números), portados do
 * protótipo. Não há equivalentes em `src/shared/utils/` no momento.
 */

const MESES_ABREV = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

/**
 * Formata uma data ISO como `DD/MM/YYYY`. Aceita tanto `YYYY-MM-DD` quanto data-hora
 * (`YYYY-MM-DDTHH:mm:ss`) — a parte de hora é descartada.
 *
 * @param iso - Data ISO (date ou date-time); `''`/inválida retorna `''`.
 */
export function fmtBR(iso: string): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  if (!y || !m || !d) return '';
  return `${d}/${m}/${y}`;
}

/**
 * Formata uma data ISO como mês abreviado + ano (ex.: `fev 2026`). Aceita `YYYY-MM-DD`
 * ou data-hora (`YYYY-MM-DDTHH:mm:ss`).
 *
 * @param iso - Data ISO (date ou date-time); `''`/inválida retorna `''`.
 */
export function monthYear(iso: string): string {
  if (!iso) return '';
  const [y, m] = iso.slice(0, 10).split('-');
  if (!y || !m) return '';
  const mes = MESES_ABREV[Number.parseInt(m, 10) - 1];
  return mes ? `${mes} ${y}` : '';
}

/**
 * Formata um número com uma casa decimal (ex.: `20` → `"20.0"`, `33.333` → `"33.3"`).
 *
 * @param n - Número a formatar.
 */
export function fmt(n: number): string {
  return (Math.round(n * 10) / 10).toFixed(1);
}
